import { render, staticRenderFns } from "./OfertaDescuentosDefault.vue?vue&type=template&id=50a83b89&"
import script from "./OfertaDescuentosDefault.vue?vue&type=script&lang=js&"
export * from "./OfertaDescuentosDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a83b89')) {
      api.createRecord('50a83b89', component.options)
    } else {
      api.reload('50a83b89', component.options)
    }
    module.hot.accept("./OfertaDescuentosDefault.vue?vue&type=template&id=50a83b89&", function () {
      api.rerender('50a83b89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Simuladores/Ofertas/descuento/OfertaDescuentosDefault.vue"
export default component.exports